/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactStatus } from './ContactStatus.js';
import {
    ContactStatusFromJSON,
    ContactStatusFromJSONTyped,
    ContactStatusToJSON,
} from './ContactStatus.js';
import type { ContactTranscriptSummary } from './ContactTranscriptSummary.js';
import {
    ContactTranscriptSummaryFromJSON,
    ContactTranscriptSummaryFromJSONTyped,
    ContactTranscriptSummaryToJSON,
} from './ContactTranscriptSummary.js';
import type { ProcessingStatusType } from './ProcessingStatusType.js';
import {
    ProcessingStatusTypeFromJSON,
    ProcessingStatusTypeFromJSONTyped,
    ProcessingStatusTypeToJSON,
} from './ProcessingStatusType.js';

/**
 * 
 * @export
 * @interface ContactSummary
 */
export interface ContactSummary {
    /**
     * 
     * @type {number}
     * @memberof ContactSummary
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactSummary
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactSummary
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactSummary
     */
    systemPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactSummary
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSummary
     */
    isInbound?: boolean;
    /**
     * 
     * @type {Array<ContactStatus>}
     * @memberof ContactSummary
     */
    statusHistory?: Array<ContactStatus>;
    /**
     * 
     * @type {ContactTranscriptSummary}
     * @memberof ContactSummary
     */
    transcript?: ContactTranscriptSummary;
    /**
     * 
     * @type {Date}
     * @memberof ContactSummary
     */
    dateCreated?: Date;
    /**
     * 
     * @type {ProcessingStatusType}
     * @memberof ContactSummary
     */
    processingStatus?: ProcessingStatusType;
}

/**
 * Check if a given object implements the ContactSummary interface.
 */
export function instanceOfContactSummary(value: object): boolean {
    return true;
}

export function ContactSummaryFromJSON(json: any): ContactSummary {
    return ContactSummaryFromJSONTyped(json, false);
}

export function ContactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'isInbound': json['isInbound'] == null ? undefined : json['isInbound'],
        'statusHistory': json['statusHistory'] == null ? undefined : ((json['statusHistory'] as Array<any>).map(ContactStatusFromJSON)),
        'transcript': json['transcript'] == null ? undefined : ContactTranscriptSummaryFromJSON(json['transcript']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'processingStatus': json['processingStatus'] == null ? undefined : ProcessingStatusTypeFromJSON(json['processingStatus']),
    };
}

export function ContactSummaryToJSON(value?: ContactSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sourceId': value['sourceId'],
        'customerPhoneNumber': value['customerPhoneNumber'],
        'systemPhoneNumber': value['systemPhoneNumber'],
        'summary': value['summary'],
        'isInbound': value['isInbound'],
        'statusHistory': value['statusHistory'] == null ? undefined : ((value['statusHistory'] as Array<any>).map(ContactStatusToJSON)),
        'transcript': ContactTranscriptSummaryToJSON(value['transcript']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'processingStatus': ProcessingStatusTypeToJSON(value['processingStatus']),
    };
}

